// extracted by mini-css-extract-plugin
export default {"box":"index_box_noDu-","mg10":"index_mg10_AlJ5b","title":"index_title_GnUDI"};